// extracted by mini-css-extract-plugin
export default {"suggestions":"suggestions--y7f6C"};